import { useEffect, useRef } from "react";

import { getViewport } from "@/src/utils/digitalData";

const DEBOUNCE_DELAY_MS = 150;

export const useDigitalDataResize = () => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    const handleResize = () => {
      if (!globalThis.digitalData) {
        return;
      }

      // Store reference to ensure it exists when timeout executes
      const digitalData = globalThis.digitalData;

      // Clear existing timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      // Set new timeout to debounce the update
      timeoutRef.current = setTimeout(() => {
        if (!digitalData) {
          return;
        }
        digitalData.page.attributes.viewport = getViewport(
          globalThis.innerWidth
        );
        digitalData.page.attributes.width = globalThis.innerWidth;
      }, DEBOUNCE_DELAY_MS);
    };

    globalThis.addEventListener("resize", handleResize);
    return () => {
      globalThis.removeEventListener("resize", handleResize);
      // Clean up timeout on unmount
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
};
